import React from 'react';

export const AjaxLoader = ({ isOpen = false }) => (
	<div className={`loader-mask ${isOpen ? '' : 'd-none'}`}>
		<div className="loader-area align-self-center">
			<div className="spinner-border text-danger" role="status" style={{ zIndex: 1300}}>
				</div>
		</div>
	</div>
);